import type { RouteObject } from "react-router-dom";
import { lazy, Suspense } from "react";
import NotFound from "../pages/NotFound";
import LoadingSpinner from "../components/LoadingSpinner";

// Lazy load the Home page
const Home = lazy(() => import("../pages/home/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <Suspense fallback={<LoadingSpinner message="Loading MunchBox..." />}>
        <Home />
      </Suspense>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
